import { FC, useContext } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { ListItemIcon, Stack } from '@mui/material';
import Icon from '../../icon';
import Text from '../../text';
import { DrawerMenuItem as DrawerMenuItemProps } from './helpers';
import { MenuCloseContext } from '@/contexts/menu';

const DrawerMenuItem: FC<DrawerMenuItemProps> = ({
  label,
  subtitle,
  onClick,
  icon,
  color,
  disabled,
}) => {
  const hasIcon = !!icon;
  const compColor = disabled ? 'grey' : color;
  const onClose = useContext(MenuCloseContext);

  const handleClick = () => {
    onClick();
    onClose?.();
  };

  return (
    <MenuItem onClick={handleClick} disabled={disabled}>
      {hasIcon && (
        <ListItemIcon>
          <Icon name={icon} size="small" color={compColor} />
        </ListItemIcon>
      )}
      <Stack>
        <Text size="small" color={compColor}>
          {label}
        </Text>
        {subtitle && (
          <Text size="small" color="grey">
            {subtitle}
          </Text>
        )}
      </Stack>
    </MenuItem>
  );
};

export default DrawerMenuItem;
